import { ChatMessage, ChatMessageContentTextBlock, DataPayload, DataPayloadType } from '../../gamma-api';

const CODE_QUOTES = '```';

const TEXT_BLOCK_TYPES = ['text'];
const CONTENT_PAYLOAD_TYPES: DataPayloadType[] = [DataPayloadType.Text, DataPayloadType.Json];

export const getChatMessageTextContent = (chatMessage: ChatMessage, payloads?: DataPayload[]): string => {
  const textBlocks = (chatMessage.content || []).filter((block) => TEXT_BLOCK_TYPES.includes(block.block_type));
  const contentPayloads = (payloads || []).filter((payload) => CONTENT_PAYLOAD_TYPES.includes(payload.type));
  const results = [];

  for (let index = 0; index <= Math.max(textBlocks.length, contentPayloads.length); index++) {
    const block = index < textBlocks.length ? textBlocks[index] : null;
    const payload = index < contentPayloads.length ? contentPayloads[index] : null;

    if (payload?.type === DataPayloadType.Json) {
      results.push(`${CODE_QUOTES}json\n${JSON.stringify(payload.data, undefined, 2)}\n${CODE_QUOTES}`);
    } else if (block) {
      results.push((block as ChatMessageContentTextBlock).text);
    } else if (payload) {
      results.push(payload.data);
    }
  }

  return results.join('\n');
};

export const getPayloadsTextContent = (payloads: DataPayload[]): string => {
  return (payloads || [])
    .map((payload) => {
      switch (payload.type) {
        case DataPayloadType.Text:
          return payload.data;
        case DataPayloadType.Json:
          return JSON.stringify(payload.data);
        default:
          return null;
      }
    })
    .filter(Boolean)
    .join('\n');
};
